import { clientWithCredentials } from '../_helpers';
import { alertConstants, orderConstants, ordersConstants } from '../_constants';
import { push } from 'react-router-redux';

export const orderAction = {
    loadOrder,
    payOrder,
    payOnlineOrder,
    cancelOrder
}

function loadOrder(id: any) {
    return function(dispatch: any){
        dispatch({
            type: orderConstants.ORDER_LOADING
        });
        clientWithCredentials(dispatch).get(`api/order/${id}`)
        .then((data)=>{
            dispatch({
                type: orderConstants.ORDER_LOADED,
                data: data.data
            });
        })
        .catch((error)=>{
            dispatch({
                type: orderConstants.ORDER_ERROR,
            });
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {
                    message: error.message,
                    level: "error"
                }
            })
        })
    }
}

function payOrder(id: any, date: any){
    return function(dispatch: any){
        clientWithCredentials(dispatch).post('api/order/confirm', {
            orderId: id,
            dateOfPayment: date,
          })
        .then(()=>{
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {message: "order_paid",
                                level: "notification" }
            });
            dispatch({
                type: ordersConstants.ORDERS_LOADING
            })
            dispatch({
                type: orderConstants.ORDER_LOADING
            })
        }).catch((error) =>{
            console.log(error);
        })
    }
}

function payOnlineOrder(id: any, date: any){
    return function(dispatch: any){
        clientWithCredentials(dispatch).post('api/order/confirmonline', {
            orderId: id,
            dateOfPayment: date,
          })
        .then(()=>{
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {message: "order_canceled",
                                level: "notification" }
            });
            dispatch({
                type: ordersConstants.ORDERS_LOADING
            })
            dispatch({
                type: orderConstants.ORDER_LOADING
            })
        }).catch((error) =>{
            console.log(error);
        })
    }
}

function cancelOrder(id: any, date: any){
    return function(dispatch: any){
        clientWithCredentials(dispatch).post(`/api/order/cancel/${id}`)
        .then(()=>{
            dispatch({
                type: alertConstants.ALERT_SHOW,
                notification: {message: "order_canceled",
                                level: "notification" }
            });
            dispatch({
                type: ordersConstants.ORDERS_LOADING
            })
            dispatch({
                type: orderConstants.ORDER_LOADING
            })
        }).catch((error) =>{
            console.log(error);
        })
    }
}